import React, { KeyboardEvent } from 'react'
import { ConnectDragSource } from 'react-dnd'
import { Icon, IconChoices } from '../../../../common/Icon'
import { theme } from '../../../../../theme/theme'
import { Dropdown, Option } from '../../../../common/Dropdown'
import { Button } from '../../../../common/Button'

interface BinderListRowItemProps {
  isAdminView: boolean
  openItem: () => void
  documentTitle: string
  documentSubtitle: string
  documentIcon: IconChoices
  isFolder: boolean
  dropdownOptions: Option[]
  documentUrl?: string
  isDragging?: boolean
  drag?: ConnectDragSource
  isOver?: boolean
}

export const BinderListRowItem = ({
  isAdminView,
  openItem,
  documentTitle,
  documentSubtitle,
  documentIcon,
  isFolder,
  dropdownOptions,
  documentUrl,
  isDragging = false,
  drag,
  isOver,
}: BinderListRowItemProps): JSX.Element => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter' && openItem && isFolder) {
      openItem()
    }
  }

  return (
    <div
      role="presentation"
      ref={isAdminView ? drag || null : null}
      className={`flex w-full items-center justify-between rounded-sm border-b py-5 px-4 
        hover:bg-neutral-96 ${isAdminView ? 'cursor-move' : 'cursor-pointer'} ${
          isOver ? 'bg-neutral-90' : 'bg-white'
        }`}
      style={{ opacity: isDragging ? 0.5 : 1 }}
      onClick={openItem}
      onKeyDown={handleKeyDown}
    >
      <div className="flex items-center">
        <div className="flex items-center gap-3 md:max-w-xl">
          {documentUrl ? (
            <div
              className="h-8 w-8 rounded-md bg-neutral-94 bg-cover bg-center"
              style={{
                backgroundImage: `url(${documentUrl})`,
              }}
            />
          ) : (
            <Icon size={32} icon={documentIcon} />
          )}
          <div className="flex flex-col">
            <p style={theme.textVariants.base}>{documentTitle}</p>
            <p style={theme.textVariants.caption} className="text-neutral-50">
              {documentSubtitle}
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        {isAdminView ? (
          <Dropdown options={dropdownOptions}>
            <Button
              icon={IconChoices.MORE}
              className="h-10 w-10 border-none bg-transparent hover:bg-neutral-85"
              disableTabIndex
            />
          </Dropdown>
        ) : (
          !isFolder && (
            <Dropdown options={dropdownOptions}>
              <Button
                icon={IconChoices.MORE}
                className="h-10 w-10 border-none bg-transparent hover:bg-neutral-85"
                disableTabIndex
              />
            </Dropdown>
          )
        )}
      </div>
    </div>
  )
}
